<template>
  <div class="n-loading-container" :class="{ small: size === 's', medium: size === 'm', large: size === 'l' }">
    <div class="lds-ring" :class="{ small: size === 's', medium: size === 'm', large: size === 'l' }">
      <div :style="ringDarkStyles()" />
      <div :style="ringDarkStyles()" />
      <div :style="ringDarkStyles()" />
      <div :style="ringDarkStyles()" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class NLoading extends Vue {
  @Prop({
    type: String,
    validator: (prop: string) => ['s', 'm', 'l'].includes(prop),
    default: 'm'
  })
  size?: String
  @Prop({ type: Boolean, default: false }) dark?: boolean
  @Prop({
    type: String,
    validator: (prop: string) => ['normal', 'success'].includes(prop),
    default: 'normal'
  })
  accent?: String

  ringDarkStyles() {
    let styles = {}

    if (this.dark) {
      styles = {
        border: '3px solid black',
        borderColor: 'black transparent transparent transparent'
      }
    } else if (this.accent === 'success') {
      styles = {
        border: '3px solid #4FE0AD',
        borderColor: '#4FE0AD transparent transparent transparent'
      }
    }

    return styles
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.n-loading-container {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &.small {
    top: calc(50% - $notch-space-3x/2);
    left: calc(50% - $notch-space-3x/2);
  }
  &.medium {
    top: calc(50% - $notch-space-6x/2);
    left: calc(50% - $notch-space-6x/2);
  }
  &.large {
    top: calc(50% - $notch-space-12x/2);
    left: calc(50% - $notch-space-12x/2);
  }
}

.lds-ring {
  display: inline-block;
  position: relative;

  &.small {
    width: $notch-space-3x;
    height: $notch-space-3x;
    div {
      width: $notch-space-3x;
      height: $notch-space-3x;
      border-width: 2px !important;
    }
  }
  &.medium {
    width: $notch-space-6x;
    height: $notch-space-6x;
    div {
      width: $notch-space-6x;
      height: $notch-space-6x;
      border-width: 3px !important;
    }
  }
  &.large {
    width: $notch-space-12x;
    height: $notch-space-12x;
    div {
      width: $notch-space-12x;
      height: $notch-space-12x;
      border-width: 6px !important;
    }
  }

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border: 3px solid #fff;
    border-radius: $notch-radius-full;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
  }
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
